module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKABAEIMA.10494c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKABAEIMA.png
// module id = 54
// module chunks = 0